import axios from 'axios'
import { apiEnum } from '../config.js'

export default function ajax(elementUI, type, url, param, successFn, completeFn, errorFn) {
  successFn = (successFn == undefined) ? () => {} : successFn;
  completeFn = (completeFn == undefined) ? () => {} : completeFn;
  errorFn = (errorFn == undefined) ? () => {} : errorFn;

  let thenFn = (response) => {
    let res = response.data;
    if(res.status == apiEnum.apiStatus.success){
      successFn(res);
    }else if(res.status == apiEnum.apiStatus.error){
      elementUI.$message({
        type: 'error',
        showClose: true,
        message: '操作失败:' + res.errMsg
      });
    }else if(res.status == apiEnum.apiStatus.fail){
      elementUI.$message({
        type: 'error',
        showClose: true,
        message: '操作失败:请检查网络是否连接正确'
      });
    }
    completeFn();
  }

  let catchFn = (error) => {
    console.log(error);
    errorFn(error);
    completeFn();
  }

  if(type == 'post'){
    var qs = require('qs');
    axios.post(url, qs.stringify(param))
    .then((response) => {
      thenFn(response);
    })
    .catch((error) => {
      catchFn(error);
    });
  }else if(type == 'get'){
    axios.get(url, {
      params: param
    })
    .then((response) => {
      thenFn(response);
    })
    .catch((error) => {
      catchFn(error);
    });
  }
}


// WEBPACK FOOTER //
// ./src/xelement/ajax.js